import { render, staticRenderFns } from "./CoFactorManage.vue?vue&type=template&id=91b3a040&scoped=true"
import script from "./CoFactorManage.vue?vue&type=script&lang=js"
export * from "./CoFactorManage.vue?vue&type=script&lang=js"
import style0 from "./CoFactorManage.vue?vue&type=style&index=0&id=91b3a040&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b3a040",
  null
  
)

export default component.exports